import { CONST_COUNTRY, formatPhone } from '@/feedback/constants';
import * as $18n from '@alife/lazada-i18n';
import { axios } from '@alife/workstation-utils';
import { createForm } from '@formily/core';
import { useCreation, useRequest } from 'ahooks';
import { Button, Divider, Flex, message } from 'antd';
import React from 'react';
import { FeedbackForm } from './components/Form';
import { FeedbackContext } from './context';
import { useLocale } from './locale';

import './index.scss';
export interface IProps {
  /**
   * 反馈平台配置
   */
  config: {
    platform: string;
    domainId: number;
  };

  /**
   * 反馈平台文案
   */
  text?: {
    subTitle?: string;
    emailHolder?: string;
    phoneHolder?: string;
    descHolder?: string;
  };

  /**
   * lago-loader 下发的组件多语言
   */
  locale?: object;

  /**
   * 帐号校验
   */
  accountRequired?: 'either-or' | 'both';

  /**
   * 提交成功callback
   */
  onSubmitted: () => void;

  /**
   * 取消callback
   */
  onCancel: () => void;

  /**
   * 录屏开始
   */
  onScreenshotStart?: () => void;

  /**
   * 录屏结束
   */
  onScreenshotEnd?: () => void;

  /**
   * 禁用截屏
   */
  disableScreenshot?: boolean;

  /**
   * 禁用截屏
   */
  disableScreenRecord?: boolean;
}

function FeedbackPanel({
  config,
  text,
  locale,
  accountRequired,
  onCancel,
  onSubmitted,
  onScreenshotStart,
  onScreenshotEnd,
  disableScreenshot,
  disableScreenRecord,
}: IProps) {
  useLocale(locale);

  const form = useCreation(
    () =>
      createForm({
        initialValues: {
          phone: '',
          email: '',
        },
      }),
    [],
  );

  const { loading, runAsync: submit } = useRequest(
    async () => {
      const data: any = await form.submit();
      if (!data.phone && !data.email) {
        return Promise.reject({
          message: /*#__PURE__*/$18n.get(
            'asc-fb.feedback-form.account.hint',
            'Please enter you login email or phone number'
          ),
        });
      }
      return axios('mtop.lazada.cco.feedback.unlogin.portal.submit', {
        data: {
          query: {
            ...data,
            ...config,
            ...formatPhone(data.phone),
            url: window.location.pathname,
          },
        },
        method: 'POST',
        noUrlQuery: true,
      });
    },
    {
      manual: true,
      onSuccess: () => {
        message.success(/*#__PURE__*/$18n.get('asc-fb.feedback-form.submit.success', 'Submit success.'));
        onSubmitted?.();
      },
      onError: (err) => {
        // form 表单校验错误不弹message
        if (Array.isArray(err)) return;
        message.error(err?.message || /*#__PURE__*/$18n.get('asc-fb.feedback-form.submit.failed', 'Submit failed.'));
      },
    },
  );

  return (
    <FeedbackContext.Provider
      value={{ onScreenshotEnd, onScreenshotStart, disableScreenshot, disableScreenRecord, text, accountRequired }}
    >
      <Flex vertical={true} justify="space-between" style={{ height: '100%' }}>
        <FeedbackForm form={form} country={CONST_COUNTRY} />
        <div>
          <Divider style={{ margin: '12px 0' }} />
          <Flex gap="small" wrap="wrap" justify="flex-end">
            <Button disabled={loading} onClick={onCancel}>
              {/*#__PURE__*/$18n.get('asc-fb.feedback-form.cancel', 'Cancel')}
            </Button>
            <Button loading={loading} type="primary" onClick={submit}>
              {/*#__PURE__*/$18n.get('asc-fb.feedback-form.submit', 'Submit')}
            </Button>
          </Flex>
        </div>
      </Flex>
    </FeedbackContext.Provider>
  );
}

export default FeedbackPanel;
